import {TextAnimations} from "./text-animation";
import {ImageReveal} from "./image-reveal";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
window.addEventListener('load', () => {
    const ecosystemHero = document.querySelector('.mksun-hero--ecosystem');
    if (ecosystemHero) {
        const TextAnimationEcosystemHero = new TextAnimations([
            {
                selector: '.mksun-hero--ecosystem h1',
                type: 'words',
                position: '='
            },
            {
                selector: '.mksun-hero--ecosystem__content__text__list__item',
                type: 'lines',
                position: '>'
            }
        ], ecosystemHero, {});

        TextAnimationEcosystemHero.init();

        TextAnimationEcosystemHero.timeLine.from(
            '.mksun-hero--ecosystem__content',
            {
                opacity: 0,
                duration: .5,
                ease: 'power1.out',
            },
            ">",
        )

        TextAnimationEcosystemHero.timeLine.from(".mksun-hero--ecosystem__content__product", {
            x: 48,
            opacity: 0,
            duration: .25,
            ease: 'power1.out',
        }, ">")

        TextAnimationEcosystemHero.animate();


        TextAnimationEcosystemHero.timeLine.from(
            '.mksun-hero__content__text__input-zip',
            {
                y: 24,
                opacity: 0,
                duration: .25,
                ease: 'power1.out',
            }, ">"
        )
    }

    const ecosystemScroll = document.querySelector('.mksun-ecosystem-scroll--ecosystem');
    if (ecosystemScroll) {
        const TextAnimationEcosystemScroll = new TextAnimations([
            {
                selector: '.mksun-ecosystem-scroll--ecosystem h2',
                type: 'words',
                position: '>'
            },
            {
                selector: '.mksun-ecosystem-scroll--ecosystem__text__content p',
                type: 'lines',
                position: '>'
            }
        ], ecosystemScroll, {}, {start: "0 75%"});

        TextAnimationEcosystemScroll.init();

        TextAnimationEcosystemScroll.timeLine.from(
            '.mksun-ecosystem-scroll--ecosystem',
            {
                opacity: 0,
                duration: .5,
                ease: 'power1.out',
                stagger: 0.1
            }
        )

        TextAnimationEcosystemScroll.animate();

        TextAnimationEcosystemScroll.timeLine.from(
            '.mksun-ecosystem-scroll--ecosystem__scroll',
            {
                opacity: 0,
                duration: .5,
                ease: 'power1.out',
                stagger: 0.1
            }, ">"
        )
    }

    const ecosystemBentoGrid = document.querySelector('.mksun-bento-grid--ecosystem');
    if (ecosystemBentoGrid) {
        const TextAnimationBentoGrid = new TextAnimations([
            {
                selector: '.mksun-bento-grid--ecosystem h2',
                type: 'words',
                position: '>'
            },
            {
                selector: '.mksun-bento-grid--ecosystem p',
                type: 'lines',
                position: '>'
            }
        ], ecosystemBentoGrid, {}, {start: "top 50%"});

        TextAnimationBentoGrid.init();

        const imageRevealBentoGrid = new ImageReveal([
            {
                selector: '.mksun-bento-grid--ecosystem__col__card',
                position: '>',
                mask: true,
                overlayColor: 'var(--neutral-300)'
            }, {
                selector: '.mksun-bento-grid--ecosystem__col__card--small:nth-child(1)',
                position: '>',
                mask: true,
                overlayColor: 'var(--neutral-300)'
            }, {
                selector: '.mksun-bento-grid--ecosystem__col__card--small:nth-child(2)',
                position: '>',
                mask: true,
                overlayColor: 'var(--neutral-300)'
            }
        ], TextAnimationBentoGrid.timeLine);

        imageRevealBentoGrid.init();
        imageRevealBentoGrid.animate();
    }

    const ecosystemVideoDetails = document.querySelector('.mksun-video-details--ecosystem');
    if (ecosystemVideoDetails) {
        const ecosystemVideoDetailsCtns = ecosystemVideoDetails.querySelectorAll('.mksun-video-details--ecosystem__ctn');

        ecosystemVideoDetailsCtns.forEach((ecosystemVideoDetailsCtn) => {
            const TextAnimationVideoDetails = new TextAnimations([
                {
                    selector: ecosystemVideoDetailsCtn.querySelectorAll('.mksun-video-details--ecosystem__ctn__item p.text-primary'),
                    type: 'words',
                    position: '>'
                },
                {
                    selector: ecosystemVideoDetailsCtn.querySelectorAll('.mksun-video-details--ecosystem__ctn__item h2'),
                    type: 'words',
                    position: '<'
                },
                {
                    selector: ecosystemVideoDetailsCtn.querySelectorAll('.mksun-video-details--ecosystem__ctn__item__content > div:not(.btn-ctn)'),
                    type: 'lines',
                    position: '>'
                }
            ], ecosystemVideoDetailsCtn, {}, {start: "top 50%"});

            TextAnimationVideoDetails.init();

            TextAnimationVideoDetails.timeLine.from(ecosystemVideoDetailsCtn.querySelectorAll(".mksun-video-details--ecosystem__ctn__item__video"), {
                opacity: 0,
                duration: .5,
                ease: 'power1.out',
            }, ">")

            TextAnimationVideoDetails.animate();

            TextAnimationVideoDetails.timeLine.from(ecosystemVideoDetailsCtn.querySelectorAll(".mksun-video-details--ecosystem__ctn__item__content .btn"), {
                y: 24,
                opacity: 0,
                duration: .5,
                ease: 'power1.out',
            }, ">")

            if (ecosystemVideoDetailsCtn.querySelector('.mksun-video-details--ecosystem__ctn__grid')) {
                const tlVideoDetailsGrid = gsap.timeline({
                    scrollTrigger: {
                        trigger: ecosystemVideoDetailsCtn.querySelector('.mksun-video-details--ecosystem__ctn__grid'),
                        start: "top 50%"
                    }
                });

                const videoDetailsGridItem = ecosystemVideoDetailsCtn.querySelectorAll('.mksun-video-details--ecosystem__ctn__grid__item');

                tlVideoDetailsGrid.from(videoDetailsGridItem, {
                    opacity: 0,
                    y: 24,
                    duration: .5,
                    ease: 'power1.out',
                    stagger: 0.1
                })

            }

        })
    }
});